import React from 'react'
import { Input as AntInput } from 'antd'
import {
  InputProps as AntInputProps,
  GroupProps as AntInputGroupProps,
  SearchProps as AntInputSearchProps
} from 'antd/lib/input/index'

import styles from './_.module.css'

export interface InputProps extends AntInputProps {
  error?: boolean
  updatePosition?: (val: number) => void
  dataId?: string | null
}

export const {
  Password: AntPassword,
  Group: AntInputGroup,
  Search: AntInputSearch
} = AntInput

export const Input: React.FC<InputProps> = ({
  className,
  disabled,
  allowClear,
  addonBefore,
  addonAfter,
  error,
  maxLength,
  name,
  placeholder,
  prefix,
  itemRef,
  size,
  step,
  min,
  max,
  suffix,
  id,
  type,
  value,
  defaultValue,
  autoComplete,
  onChange,
  onPressEnter,
  onBlur,
  onFocus,
  onWheel,
  onKeyDown,
  updatePosition,
  onPaste,
  autoFocus = false,
  dataId = null,
  style
}) => (
  <AntInput
    style={style}
    className={`${className} ${styles.input} ${error ? 'ant-input-error' : ''}`}
    addonBefore={addonBefore}
    addonAfter={addonAfter}
    allowClear={allowClear}
    disabled={disabled}
    maxLength={maxLength}
    onFocus={e => {
      updatePosition?.(e.target.offsetTop)
      onFocus?.(e)
    }}
    onBlur={e => {
      updatePosition?.(0)
      onBlur?.(e)
    }}
    onWheel={onWheel}
    prefix={prefix}
    ref={itemRef}
    size={size}
    suffix={suffix}
    name={name}
    min={min}
    max={max}
    step={step}
    type={type}
    value={value}
    defaultValue={defaultValue}
    autoComplete={autoComplete}
    onChange={onChange}
    placeholder={placeholder}
    onPressEnter={onPressEnter}
    autoFocus={autoFocus}
    id={id}
    data-cy={name}
    onKeyDown={onKeyDown}
    onPaste={onPaste}
    {...(dataId && { 'data-id': dataId })}
  />
)

export const Password: React.FC<InputProps> = ({
  disabled,
  className,
  error,
  maxLength,
  name,
  placeholder,
  prefix,
  size,
  suffix,
  value,
  onChange,
  onPressEnter,
  onBlur,
  autoComplete = 'off'
}) => (
  <AntPassword
    className={`${className} ${styles.input} ${error ? 'ant-input-error' : ''}`}
    disabled={disabled}
    maxLength={maxLength}
    name={name}
    prefix={prefix}
    size={size}
    suffix={suffix}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    onPressEnter={onPressEnter}
    onBlur={onBlur}
    data-cy={name}
    autoComplete={autoComplete}
  />
)

export const InputGroup: React.FC<AntInputGroupProps> = ({
  compact,
  size,
  children,
  className
}) => (
  <AntInputGroup compact={compact} size={size} className={className}>
    {children}
  </AntInputGroup>
)

export const InputSearch: React.FC<AntInputSearchProps> = ({
  className,
  disabled,
  allowClear,
  addonBefore,
  addonAfter,
  maxLength,
  name,
  placeholder,
  prefix,
  size,
  step,
  min,
  max,
  suffix,
  id,
  type,
  value,
  onChange,
  onPressEnter,
  onBlur,
  onFocus,
  onKeyDown,
  autoFocus = false,
  enterButton,
  loading,
  onSearch
}) => (
  <AntInputSearch
    className={`${className} ${styles.input} $`}
    addonBefore={addonBefore}
    addonAfter={addonAfter}
    allowClear={allowClear}
    disabled={disabled}
    maxLength={maxLength}
    onFocus={e => {
      onFocus?.(e)
    }}
    onBlur={e => {
      onBlur?.(e)
    }}
    prefix={prefix}
    size={size}
    suffix={suffix}
    name={name}
    min={min}
    max={max}
    step={step}
    type={type}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    onPressEnter={onPressEnter}
    autoFocus={autoFocus}
    id={id}
    data-cy={name}
    onKeyDown={onKeyDown}
    onSearch={onSearch}
    loading={loading}
    enterButton={enterButton}
  />
)
